import React, { useState, useEffect } from 'react';
import '../styles/Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.pageYOffset > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.style.overflow = !menuOpen ? 'hidden' : '';
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  };

  const handleAnchorClick = (e, href) => {
    e.preventDefault();
    if (href === '#') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      const target = document.querySelector(href);
      if (target) {
        const headerHeight = document.querySelector('header').offsetHeight;
        const targetPosition = target.offsetTop - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    }
    closeMenu();
  };

  return (
    <header className={scrolled ? 'scrolled' : ''}>
      <nav className="container">
        <a href="#" className="logo" onClick={(e) => handleAnchorClick(e, '#')}>Eva Baris</a>
        
        <button 
          className={`menu-btn ${menuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <div className="desktop-menu">
          <a href="#about" onClick={(e) => handleAnchorClick(e, '#about')}>Nice to meet</a>
          <a href="#services" onClick={(e) => handleAnchorClick(e, '#services')}>Alles is communicatie</a>
          <a href="#contact" onClick={(e) => handleAnchorClick(e, '#contact')}>Contact</a>
        </div>
      </nav>

      <div className={`menu ${menuOpen ? 'active' : ''}`}>
        <a href="#about" onClick={(e) => handleAnchorClick(e, '#about')}>Nice to meet</a>
        <a href="#services" onClick={(e) => handleAnchorClick(e, '#services')}>Communicatie</a>
        <a href="#contact" onClick={(e) => handleAnchorClick(e, '#contact')}>Contact</a>
      </div>
    </header>
  );
};

export default Header;